import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import SimpleLock from "src/components/icons/SimpleLock";
import { ApplicationStore } from "src/store";
import { getVehicleThumbnail } from "src/store/selectors/vehicles";

interface Props {
    isDealerVehicle: boolean;
    onLoad: () => void;
    vin: string;
    isVehicleGone: boolean;
}

const VehicleHeaderThumbnail = ({
    thumbnail,
    onLoad,
    isDealerVehicle,
    isVehicleGone,
}: Props & ReturnType<typeof mapStateToProps>) => {
    const { t } = useTranslation();

    const RenderIfVehicleNotInStock = () => (
        <Overlay>
            <OverlayText>{t("MyGarage.TableCompare.VehicleHeader.NoLongerAvailable.text")}</OverlayText>
        </Overlay>
    );

    return (
        <div className="VehicleHeaderThumbnail">
            <img className="VehicleHeaderThumbnail__image" src={thumbnail} onLoad={onLoad} alt={""} />
            {isDealerVehicle && (
                <>
                    <Overlay>
                        <StyledSimpleLock />
                        <OverlayText>{t("VehicleHeaderThumbnail.overlayText")}</OverlayText>
                    </Overlay>
                </>
            )}
            {isVehicleGone && <RenderIfVehicleNotInStock />}
        </div>
    );
};

const Overlay = styled.div.attrs(() => ({
    className: "VehicleHeaderThumbnail__overlay",
}))`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    flex-flow: column;
    height: 100%;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 100%;
`;

const StyledSimpleLock = styled(SimpleLock).attrs(() => ({
    className: "VehicleHeaderThumbnail__overlay-icon",
}))`
    color: #fff;
    height: 30px;
    margin-top: -14px;
    width: 25px;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        height: 40px;
        margin-top: -10px;
        width: 35px;
    }
`;

const OverlayText = styled.div.attrs(() => ({
    className: "VehicleHeaderThumbnail__overlay-text",
}))`
    font-size: 10px;
    font-weight: bold;
    margin-top: 4px;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        font-size: 16px;
        margin-top: 8px;
    }
`;

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => ({
    thumbnail: getVehicleThumbnail(state, vin),
});

export default connect(mapStateToProps)(VehicleHeaderThumbnail);
